import Nullstack from 'nullstack';
export default function IconVocabulary({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vocabulary",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v16"
  }), "   ", Nullstack.element("path", {
    d: "M7 7h1"
  }), "   ", Nullstack.element("path", {
    d: "M7 11h1"
  }), "   ", Nullstack.element("path", {
    d: "M16 7h1"
  }), "   ", Nullstack.element("path", {
    d: "M16 11h1"
  }), "   ", Nullstack.element("path", {
    d: "M16 15h1"
  }), " ");
}